export const api_key = "CNCP29o0Lcije1ncD9RE";
export const scan_sdk_api_key = "CNCPp3JK0oL3VU81pF2l";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-uat-one-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") =>
  new URL(url, "https://sdk-one-uat.carenow.healthcare");
// export const flyy_partner_id = "94d1585895da21a1b1ab";

export const sdkUnityURL = (url = "") =>
  new URL(url, "https://sdk-staging.carenow.healthcare");

// ALlergy Ai

export const allergy_ai_api_key = "CPAL1U1IKGT3Ke5gtW2b";
export const allergy_ai_api_secret_key =
  "ZRO8pBbe9MMhh4OOV2JFa9VC0Uc7zWlYTkWKDhlV";

// Derma Ai/Dental Ai

export const derma_api_key = "CNCPDe9s5jS1WisKb8N6";
export const derma_api_secret_key = "jEEpzyuEWW0TiZkyRyWLhvyuJdWlst9tovvHmutX";
